<script>
  import { supabase } from "../auth.js";

  let email = "";
  let password = "";
  let signup = false;

  function handleLogin() {
    supabase.auth
      .signIn({ email, password })
      .then((response) => {
        response.error && alert(response.error.message);
        alert("Erfolgreich eingeloggt mit " + response.user.email);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleSignup() {
    supabase.auth
      .signUp({ email, password })
      .then((response) => {
        response.error && alert(response.error.message);
        alert("Erfolgreich eingeloggt mit " + response.user.email);
      })
      .catch((err) => {
        console.log(err);
      });
  }
</script>

<div class="flex flex-col h-screen mx-auto max-w-7xl">
  <div class="grid mx-2 my-20 place-items-center">
    <img
      src="/img/logos/fc_cologne_logo.png"
      alt="fc cologne logo"
      width="150"
      class="p-4 mx-auto"
    />
    <div
      class="w-11/12 p-12 px-6 py-10 shadow-md bg-gray-50 bg-opacity-90 rounded-xl sm:w-8/12 md:w-6/12 sm:px-10 sm:py-6 lg:shadow-lg "
    >
      <h2 class="text-3xl font-semibold text-center text-gray-800 lg:text-4xl">
        {signup ? "Registrieren" : "Login"}
      </h2>

      <form
        class="mt-10"
        on:submit|preventDefault={signup ? handleSignup : handleLogin}
      >
        <label
          for="email"
          class="block text-xs font-semibold text-gray-600 uppercase"
          >E-mail</label
        >
        <input
          id="email"
          type="email"
          name="email"
          autocomplete="email"
          placeholder="e-mail adresse"
          class="block w-full p-3 mt-2 text-gray-500 border-b-2 border-gray-100 rounded-lg appearance-none focus:text-gray-800 focus:outline-none focus:border-gray-200"
          required
          bind:value={email}
        />

        <label
          for="password"
          class="block mt-2 text-xs font-semibold text-gray-600 uppercase"
          >Passwort</label
        >
        <input
          id="password"
          type="password"
          name="password"
          autocomplete="password"
          placeholder="passwort"
          class="block w-full p-3 mt-2 mb-4 text-gray-500 border-b-2 border-gray-100 rounded-lg appearance-none focus:text-gray-800 focus:outline-none focus:border-gray-200"
          required
          bind:value={password}
        />

        <button type="button" on:click={() => (signup = !signup)}
          >{signup ? "Zum Login" : "Zur Registrierung"}</button
        >

        <button
          type="submit"
          class="w-full py-3 mt-6 text-white rounded-md bg-gradient-to-r from-fcred to-white focus:outline-none hover:shadow-none"
        >
          {signup ? "Registrieren" : "Login"}
        </button>
      </form>
    </div>
  </div>
</div>
